export const attachScrollToElement = () => {
	const scrollLinks = document.querySelectorAll('a[href^="#"]');
	scrollLinks.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const clickTarget = e.target;
			const targetId = clickTarget.href
				? clickTarget.href.split('#')[1]
				: clickTarget.closest('a').href.split('#')[1];

			if (targetId) {
				const target = document.getElementById(targetId);
				let yOffset = -100;
				const targetPosition = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: targetPosition, behavior: "smooth" });
			}
		});
	});
};

export const loadWithHash = () => {
	const { hash } = window.location;
	if (window.location.hash !== '') {
		const target = document.getElementById(hash.replace('#', ''));
		let yOffset = -100;
		const targetPosition = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
		if (target) {
      window.scrollTo({ top: targetPosition, behavior: "auto" });
      history.pushState("", "", `${location.pathname}${location.search}`);
		}
	}
}